// extracted by mini-css-extract-plugin
export default {"infoTopic":"NewCreate_infoTopic__PHsBX","text":"NewCreate_text__XvLI9","container":"NewCreate_container__iWXEm"};